import axios from "axios";

export const PublicHttpService = axios.create();

PublicHttpService.defaults.baseURL = `${
    import.meta.env.VITE_CORPORA_SERVICE_URL as string
}`;